export const SUPER_ADMIN_ROLES = ['系统管理员'];
export const SYS_ADMIN_ROLES = ['系统管理员'];
export const SCHOOL_ADMIN_ROLES = ['学校管理员'];
export const DEPT_ADMIN_ROLES = ['部门管理员'];
export const MEMBER_ROLES = ['专家'];
export const YLXK_ADMIN_ROLES = ['一流学科管理员'];
